import { FormGroup } from '@angular/forms';
import { GetCountriesData } from '@shared';
import { BrandModelAffectedControl, CodeUKTZEDCategoryData, CodeUKTZEDGoodsType } from './ii-code-uktzed.constants';

export function trimCodeUKTZEDByRecipientCountry(
  codeUKTZED: string = '',
  country: GetCountriesData,
  isLoyaltyRozniza: boolean,
  isSubmit: boolean = false,
): string {
  if (!codeUKTZED) {
    return '';
  }

  if (!country || !country.CodeUKTZED) {
    return codeUKTZED;
  }

  if (isSubmit) {
    // We don't trim the code for organizations
    const trimLength = isLoyaltyRozniza ? country.CodeUKTZED.maxLength : codeUKTZED.length;

    return codeUKTZED.slice(0, trimLength);
  } else {
    return codeUKTZED.slice(0, country.CodeUKTZED.maxLength);
  }
}

export function padCodeUKTZEDDestByCountry(
  codeUKTZEDDest: string = '',
  country: GetCountriesData,
  isLoyaltyRozniza: boolean,
  isSubmit: boolean = false,
): string {
  if (!codeUKTZEDDest) {
    return '';
  }

  if (!country) {
    return codeUKTZEDDest;
  }

  // First, trim the code according to the recipient country's rules
  const trimmedCodeUKTZEDDest = trimCodeUKTZEDByRecipientCountry(codeUKTZEDDest, country, isLoyaltyRozniza, isSubmit);
  const minLength = country.CodeUKTZEDDest.minLength;

  // If the code is shorter than the minimum length, pad it with zeros
  if (trimmedCodeUKTZEDDest.length < minLength) {
    return trimmedCodeUKTZEDDest.padEnd(minLength, '0');
  }

  return trimmedCodeUKTZEDDest;
}

export function getCategoryNameByCodeUKTZED(code: string): CodeUKTZEDGoodsType | null {
  if (!code) {
    return null;
  }

  const codeAsString = String(code);

  const [categoryName] = Object.entries(CodeUKTZEDCategoryData)
    .find(([, entry]) =>
      entry.regexList.some(regex => regex.test(codeAsString)),
    ) || [];

  return categoryName as CodeUKTZEDGoodsType ?? null;
}

export function handleCodeUKTZED(codeUKTZED: string, formGroup: FormGroup, isLoyaltyRozniza: boolean = false): void {
  if (!isLoyaltyRozniza) {
    return;
  }

  const categoryName = getCategoryNameByCodeUKTZED(codeUKTZED);
  const category = categoryName ? CodeUKTZEDCategoryData[categoryName] : null;

  if (!category) {
    const affectedControl = formGroup.get(BrandModelAffectedControl.controlName);
    affectedControl.reset(null);
    affectedControl.disable();
    affectedControl.setValidators(BrandModelAffectedControl.defaultValidators);
    affectedControl.updateValueAndValidity();
    affectedControl.markAsTouched();
    return;
  }

  category.affectedControls.forEach(control => {
    const formControl = formGroup.get(control.controlName);
    formControl.setValidators(control.validators);
    formControl.enable();
    formControl.updateValueAndValidity();
    formControl.markAsTouched();
  });
}
